import dayjs, { Dayjs } from 'dayjs'

// KPI payment file is finalized at 17:30 on the 2nd of each month.
// After this cutoff, payment dates cannot be set to the previous month.
const KPI_CUTOFF_DAY = 2
const KPI_CUTOFF_HOUR = 17
const KPI_CUTOFF_MINUTE = 30

/**
 * Returns the minimum allowed payment date if the KPI cutoff has passed,
 * or null if there's no restriction (before the cutoff).
 *
 * After 17:30 on the 2nd → minDate = 1st of current month
 */
export function getKpiPaymentCutoffMinDate(): Dayjs | null {
    const now = dayjs()
    const day = now.date()
    const hour = now.hour()
    const minute = now.minute()

    const isPastCutoff =
        day > KPI_CUTOFF_DAY ||
        (day === KPI_CUTOFF_DAY &&
            (hour > KPI_CUTOFF_HOUR ||
                (hour === KPI_CUTOFF_HOUR && minute >= KPI_CUTOFF_MINUTE)))

    if (!isPastCutoff) return null

    return now.startOf('month')
}
